import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#3385E7",
      d: "M22 12a4.086 4.086 0 0 0-1.806-3.394A4.088 4.088 0 0 0 19.07 4.93c-.999-1-2.386-1.373-3.677-1.122A4.086 4.086 0 0 0 12 2a4.086 4.086 0 0 0-3.394 1.807A4.087 4.087 0 0 0 4.93 4.929c-1 .999-1.373 2.386-1.122 3.677A4.086 4.086 0 0 0 2 12c0 1.413.717 2.659 1.807 3.394a4.087 4.087 0 0 0 1.122 3.677c.999 1 2.386 1.373 3.677 1.122A4.086 4.086 0 0 0 12 22a4.086 4.086 0 0 0 3.394-1.806 4.087 4.087 0 0 0 3.677-1.123c1-.999 1.373-2.386 1.122-3.677A4.086 4.086 0 0 0 22 12Zm-10.075 2.849a1.668 1.668 0 0 1-2.352-.004l-1.992-1.93a.455.455 0 0 1-.01-.643l.528-.545a.455.455 0 0 1 .643-.01l2 1.94 4.517-4.433a.454.454 0 0 1 .642.005l.533.54a.455.455 0 0 1-.005.643l-4.504 4.437Z"
    }, null, -1)
  ]))]))
}
export default { render: render }